import React from 'react';
import { useLocation } from 'react-router-dom';
import biruxBronce112 from './../images/biruxBronce112.png';
import biruxOro112 from './../images/biruxOro112.png';
import biruxComodin112 from './../images/biruxComodin112.png';
import cofre112 from './../images/cofre112v2.png';

const EconomyBox = ({ birux, overBox, biruxOro, biruxComodin }) => {
    // En el panel de admin no pinta nada la economia de la cuenta con la que se navega.
    if (useLocation().pathname.toLowerCase().startsWith('/adminlogin')) return null;
    return (
        <div className="economyBox multiBox">
            <div className='economyMenu'>
                <img src={biruxBronce112}></img>
                <span className='heroes'>{birux}</span></div>
            <div className='economyMenu'>
                <img src={biruxComodin112}></img>
                <span className='heroes'>{biruxComodin || 0}</span>
            </div>
            <div className='economyMenu'>
                <img src={cofre112}></img>
                <span className='heroes'>{overBox}</span>
            </div>
            <div className='economyMenu'>
                <img src={biruxOro112}></img>
                <span className='heroes'>{biruxOro}</span>
            </div>
        </div>
    )
}

export default EconomyBox;